import {Loader} from "../../../components/Utils/loader/Loader";
import {WidgetResponse} from "../../DashboardContainer";
// Local
import {EquipmentPieChart, EquipmentPieChartRow} from "../charts/equipmentPieChart";
import {CHART_COLORS, WidgetBadge, WidgetBadgeType} from "../DashboardWidget";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {VeBoxCard} from "../../../components/card/VeBoxCard";
import AutoSizer from "react-virtualized-auto-sizer";

declare var AppTranslations: AppTranslations;

// React
import React = require("react");

interface EquipmentWidgetState {
    response: EquipmentWidgetResponse;
    currentSelection: string;
}

interface EquipmentsWidgetProps {
    data: WidgetResponse;
    title: string;
    stackManager: any;
    headerClassName?: string;
}

interface EquipmentWidgetResponse {
    items: EquipmentItem[];
}

interface EquipmentItem {
    name: string;
    image: string;
    value: number;
    idsToFilter: number[];
    modelLevel: boolean;
}

export class EquipmentWidget extends React.Component<EquipmentsWidgetProps, EquipmentWidgetState> {

    constructor(props: EquipmentsWidgetProps) {
        super(props);

        this.state = {
            response: undefined,
            currentSelection: undefined,
        };

        this.retrieveData();
    }

    public componentDidUpdate() {
        const equipmentRows = document.getElementsByClassName("equipment-widget__row");
        for (let i = 0; i < equipmentRows.length; i++) {
            const equipmentRow = equipmentRows[i] as HTMLDivElement;

            equipmentRow.onclick = (event) => {
                const dataElement: EquipmentItem = this.state.response.items[i];
                if (dataElement.modelLevel != true) {
                    this.props.stackManager.addNewLevel("EquipmentListLevel", {
                        typeIds: dataElement.idsToFilter,
                        isModelLevel: dataElement.modelLevel,
                    });
                } else {
                    this.props.stackManager.addNewLevel("EquipmentListLevel", {
                        modelName: dataElement.name,
                        isModelLevel: dataElement.modelLevel,
                        modelId: dataElement.idsToFilter[0],
                    });
                }
            };
            equipmentRow.onmouseover = () => {
                equipmentRow.className += " active";
                const selection = equipmentRow.getAttribute("data-equipment-id");
                if (this.state.currentSelection !== selection) {
                    this.setState({
                        currentSelection: selection,
                    });
                }
            };
            equipmentRow.onmouseleave = () => {
                equipmentRow.classList.remove("active");
                this.setState({
                    currentSelection: undefined,
                });
            };
        }
    }

    public render() {
        if (!this.state.response) {
            return <div className="equipment-widget">
                <Loader/>
            </div>;
        }
        const dataSet: EquipmentPieChartRow[] = this.state.response.items.map((item, i) => {
            return {
                label: `${i}`,
                frequency: item.value,
                color: CHART_COLORS[i % CHART_COLORS.length],
                id: `${i}`,
            };
        });

        const equipmentItems = this.state.response.items.map((item: EquipmentItem, i) => {
            return (
                <div
                    key={i}
                    className="equipment-widget__row"
                    data-equipment-id={i}
                    data-id-filter={item.idsToFilter}
                    data-modal-level={item.modelLevel}
                >
                    <div className="color" style={{backgroundColor: CHART_COLORS[i % CHART_COLORS.length]}}/>
                    <img className="image" src={`images/component-icons/iconPlant-${item.image}.png`}/>
                    <span className="text" title={item.name}>{item.name}</span>
                </div>
            );
        });

        return (
            <VeBoxCard className="equipment-widget home-dashboard-card">
                <VeBoxCard.Header
                    className={"equipment-widget__header space-between " + (this.props.headerClassName || "")}
                    title={this.props.title.toUpperCase()}
                    titleClassName={"lowercase capitalize"}
                    singleLineTitle={true}
                    back={
                        <WidgetBadge type={WidgetBadgeType.COMMERCIAL}/>
                    }
                />
                <VeBoxCard.Body className="equipment-widget__content">
                    <div className="equipment-widget__container equipment-widget__container--left">
                        <div className="equipment-widget__chart">
                            <AutoSizer style={{width: "auto", height: "auto"}}>
                                {({height, width}) =>
                                    <EquipmentPieChart
                                        radius={Math.min(width, height) / 3}
                                        data={dataSet}
                                        selectedItem={this.state.currentSelection}
                                        onPathHover={() => {
                                        }}
                                    />
                                }
                            </AutoSizer>
                        </div>
                    </div>
                    <div className="equipment-widget__container equipment-widget__container--right">
                        {equipmentItems}
                    </div>
                </VeBoxCard.Body>
            </VeBoxCard>
        );
    }

    private retrieveData(): void {

        const dataUrl: string = this.props.data.dataUrl;
        Ajax.vbxAjax({
            url: dataUrl,
            type: "GET",
            cache: false,
            success: (response: EquipmentWidgetResponse) => {
                if (response) {
                    response.items = response.items.sort((a, b) => b.value - a.value);
                    this.setState({
                        response,
                    });
                }
            },
        });
    }
}
